import React from 'react';
import { ArrowUpRightIcon, CodeIcon } from 'lucide-react';
export function StudioCallout() {
  return <section className="py-12 bg-white border-y border-gray-100" data-id="element-372">
      <div className="container mx-auto px-4" data-id="element-373">
        <a href="https://www.swedenmark.studio" target="_blank" rel="noopener noreferrer" className="group block max-w-4xl mx-auto bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 rounded-2xl p-8 md:p-10 hover:shadow-lg hover:border-slate-300 transition-all" data-id="element-374">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8" data-id="element-375">
            <div className="shrink-0 p-4 bg-white rounded-xl border border-slate-200 shadow-sm" data-id="element-376">
              <CodeIcon size={32} className="text-slate-700" data-id="element-377" />
            </div>
            <div className="flex-1" data-id="element-378">
              <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2" data-id="element-379">
                Sister Studio
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-380">
                Need a custom application, web platform, or mobile app built
                from scratch?
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-381">
                Our sister studio handles bespoke product development.
              </p>
            </div>
            <div className="shrink-0 inline-flex items-center gap-2 text-slate-900 font-semibold group-hover:gap-3 transition-all" data-id="element-382">
              Visit Swedenmark Studio
              <ArrowUpRightIcon size={18} data-id="element-383" />
            </div>
          </div>
        </a>
      </div>
    </section>;
}